import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import './Videos.css';
import FooterAction from '../components/FooterAction';

const API_KEY = 'AIzaSyDTPXZXCV8U3bOBHA_DR1TRKMy8UUgr5Nc';
const CHANNEL_HANDLE = '2gs_likegucci93';

export default function Videos() {
  const [videos, setVideos]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);
  const [playing, setPlaying] = useState(null);

  useEffect(() => {

  const handler = (e) => {
    if (e.key === "Escape") {
      setPlaying(null);
    }
  };

  window.addEventListener("keydown", handler);

  return () =>
    window.removeEventListener("keydown", handler);

}, []);

useEffect(() => {

  if (playing) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

}, [playing]);
  useEffect(() => {
    async function fetchVideos() {
      try {
        // Step 1 — resolve handle → channel ID
        const chRes = await fetch(
          `https://www.googleapis.com/youtube/v3/channels?part=id&forHandle=${CHANNEL_HANDLE}&key=${API_KEY}`
        );
        const chData = await chRes.json();

        if (!chData.items?.length) throw new Error('Channel not found');
        const channelId = chData.items[0].id;

        // Step 2 — get uploads playlist ID
        const detailRes = await fetch(
          `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${channelId}&key=${API_KEY}`
        );
        const detailData = await detailRes.json();
        const uploadsId = detailData.items[0].contentDetails.relatedPlaylists.uploads;

        // Step 3 — get videos from uploads playlist
        const vidRes = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${uploadsId}&maxResults=50&key=${API_KEY}`
        );
        const vidData = await vidRes.json();

        const vids = vidData.items
          .map(item => ({
            id: item.snippet.resourceId.videoId,
            title: item.snippet.title,
            thumb: item.snippet.thumbnails?.maxres?.url
              || item.snippet.thumbnails?.high?.url
              || item.snippet.thumbnails?.medium?.url,
            date: item.snippet.publishedAt,
          }))
          .filter(v => v.id && v.title !== 'Deleted video' && v.title !== 'Private video');

        setVideos(vids);
      } catch (err) {
        setError('Could not load videos. Please try again later.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    fetchVideos();
  }, []);

  return (
    <div className="videos-page">
      <Navbar />

      {/* ── Player overlay ── */}
      {playing && (
        <div
          className="video-player-overlay"
          onClick={() => setPlaying(null)}
        >

          <div
            className="video-player-wrap"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="video-player-header">
              {playing.title}
            </div>

            <button
              className="video-close"
              onClick={() => setPlaying(null)}
            >
              ✕
            </button>

            <iframe
              src={`https://www.youtube.com/embed/${playing.id}?autoplay=1&rel=0`}
              title={playing.title}
              className="video-iframe"
              allow="autoplay; encrypted-media; fullscreen"
              allowFullScreen
            />

          </div>

        </div>
      )}

      {/* ── Content ── */}
      <div className="videos-container">
        {loading && (
          <div className="videos-status">
            <div className="videos-spinner" />
            <p>Loading videos...</p>
          </div>
        )}

        {error && !loading && (
          <div className="videos-status">
            <p className="videos-error">{error}</p>
          </div>
        )}

        {!loading && !error && videos.map(v => (
          <div
            key={v.id}
            className="video-card"
            onClick={() => setPlaying(v)}
          >
            <div className="video-thumb-wrap">
              <img
                src={v.thumb}
                alt={v.title}
                className="video-thumb"
                onError={e => {
                  e.target.src = `https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`;
                }}
              />
              <div className="video-play-btn">
                <svg viewBox="0 0 24 24" fill="white" width="52" height="52">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>

      <FooterAction />
    </div>
  );
}
// import React from 'react';
// import Navbar from '../components/Navbar';
// import './SubPage.css';
// import FooterAction from '../components/FooterAction';

// export default function Videos() {
//   return (
//     <div className="subpage">
//       <Navbar />
//       <div className="subpage-content">
//         <h1 className="subpage-title">Videos</h1>
//         <p className="subpage-coming">Coming soon.</p>
//       </div>

//       <FooterAction />
//     </div>
//   );
// }
